module.exports = __webpack_public_path__ + "img/IMG_1458_FoamcoreMatted.ef1818dd.jpg";